import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT, PolicyServerEnvironment } from '@warema/shared/models';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { PolicyResult } from './policy-result';

@Injectable({
    providedIn: 'root',
})
export class PolicyService {
    private readonly _http = inject(HttpClient);
    private readonly _environment = inject<PolicyServerEnvironment>(ENVIRONMENT);

    public policies$ = new BehaviorSubject<PolicyResult>(null);

    public loadPoliciesById(): Promise<PolicyResult> {
        if (!this._environment.policyServer.url) {
            const policyResult = new PolicyResult();
            policyResult.isError = false;

            return new Promise<PolicyResult>(() => policyResult);
        }

        return new Promise<PolicyResult>(resolve => {
            this._http.get<PolicyResult>(this._environment.policyServer.url).subscribe({
                next: result => {
                    this.policies$.next(result);
                    resolve(result);
                },
            });
        });
    }

    public loadPoliciesByPath(path: string): Observable<void> {
        if (!this._environment.policyServer.url) {
            return of();
        }

        return this._http
            .get<PolicyResult>(this._environment.policyServer.url + path)
            .pipe(map(result => this.policies$.next(result)));
    }
}
